module.exports = Package['jagi:astronomy'];